const unwrap = (value) => value?.data ?? value;

export function matchNumber(match, message) {
  const data = unwrap(match) || {};
  const identity = data.match_identity || data;
  return identity.local_id != null && identity.local_id !== ""
    ? message("matchIdentity.number", { number: identity.local_id })
    : "";
}

export function matchStage(match, message) {
  const data = unwrap(match) || {};
  const identity = data.match_identity || data;
  const group = identity.is_group_match === true || identity.is_group_match === 1 || identity.stage_type === "group";
  if (group) {
    return [
      message("matchIdentity.groups"),
      identity.round != null ? message("matchIdentity.round", { round: identity.round }) : null,
      identity.group_name,
    ]
      .filter(Boolean)
      .join(" · ");
  }
  const round = identity.rounds_until_final;
  if (round != null && round !== "" && Number(round) >= 0 && Number(round) <= 4) {
    return message(`matchIdentity.round${Number(round)}`);
  }
  if (identity.round != null) return message("matchIdentity.round", { round: identity.round });
  return identity.round_label || identity.match_stage || message("matchIdentity.missingStage");
}

export function formatMatchIdentity(match, message) {
  const data = unwrap(match) || {};
  const identity = data.match_identity || data;
  const names = [identity.tournament_name || unwrap(data.tournament)?.name].filter(Boolean);
  return [...new Set(names), matchStage(data, message), matchNumber(data, message)].join(" · ");
}
